import { makeStyles } from '@material-ui/core'

export default makeStyles({
  fab: {
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    backgroundColor: '#B22222',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0)',
    },
  },
})
